import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  Co2Section,
} from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';

export function getSectorTranslate(sector: Sector): string {
  return sector ? translate(`Sector.${sector}`) : '';
}

export function getCo2SectionTranslate(section: Co2Section): string {
  return translate(`Co2.Sections.${section}`);
}

export function getQuestionTranslate(
  category: string,
  propName: string,
): string {
  const defaultValue = propName;
  const translateKey = `ImpactQuestion.${category}.${propName}Title`;
  const out = translate(translateKey, defaultValue);
  return out;
}

export function getCategoryTranslate(category: string): string {
  const categoryCasted = category as Category;
  return translate(`ImpactQuestion.${categoryCasted}.question-title`);
}
